/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiPerson,
    InternalApiPersonFromJSON,
    InternalApiPersonToJSON,
    InternalApiPersonEvents,
    InternalApiPersonEventsFromJSON,
    InternalApiPersonEventsToJSON,
    InternalApiPersonExportQuery,
    InternalApiPersonExportQueryFromJSON,
    InternalApiPersonExportQueryToJSON,
    InternalApiPersonSearchQuery,
    InternalApiPersonSearchQueryFromJSON,
    InternalApiPersonSearchQueryToJSON,
    InternalApiPersonsPage,
    InternalApiPersonsPageFromJSON,
    InternalApiPersonsPageToJSON,
} from '../models';

export interface ExportPersonsRequest {
    internalApiPersonExportQuery: InternalApiPersonExportQuery;
}

export interface FindAllPersonsInternalRequest {
    internalApiPersonSearchQuery: InternalApiPersonSearchQuery;
}

export interface FindPersonByIdInternalRequest {
    personId: string;
}

export interface FindPersonHistoryEventsRequest {
    personId: string;
}

/**
 * 
 */
export class PersonInternalApi extends runtime.BaseAPI {

    /**
     * Check if any Persons exist
     */
    async checkIfPersonsExistRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/exist`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Check if any Persons exist
     */
    async checkIfPersonsExist(initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.checkIfPersonsExistRaw(initOverrides);
        return await response.value();
    }

    /**
     * Export persons
     */
    async exportPersonsRaw(requestParameters: ExportPersonsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiPersonExportQuery === null || requestParameters.internalApiPersonExportQuery === undefined) {
            throw new runtime.RequiredError('internalApiPersonExportQuery','Required parameter requestParameters.internalApiPersonExportQuery was null or undefined when calling exportPersons.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/export`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiPersonExportQueryToJSON(requestParameters.internalApiPersonExportQuery),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Export persons
     */
    async exportPersons(requestParameters: ExportPersonsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.exportPersonsRaw(requestParameters, initOverrides);
    }

    /**
     * Fetch all persons
     */
    async findAllPersonsInternalRaw(requestParameters: FindAllPersonsInternalRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiPersonsPage>> {
        if (requestParameters.internalApiPersonSearchQuery === null || requestParameters.internalApiPersonSearchQuery === undefined) {
            throw new runtime.RequiredError('internalApiPersonSearchQuery','Required parameter requestParameters.internalApiPersonSearchQuery was null or undefined when calling findAllPersonsInternal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/persons`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiPersonSearchQueryToJSON(requestParameters.internalApiPersonSearchQuery),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiPersonsPageFromJSON(jsonValue));
    }

    /**
     * Fetch all persons
     */
    async findAllPersonsInternal(requestParameters: FindAllPersonsInternalRequest, initOverrides?: RequestInit): Promise<InternalApiPersonsPage> {
        const response = await this.findAllPersonsInternalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch person by id
     */
    async findPersonByIdInternalRaw(requestParameters: FindPersonByIdInternalRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiPerson>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling findPersonByIdInternal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiPersonFromJSON(jsonValue));
    }

    /**
     * Fetch person by id
     */
    async findPersonByIdInternal(requestParameters: FindPersonByIdInternalRequest, initOverrides?: RequestInit): Promise<InternalApiPerson> {
        const response = await this.findPersonByIdInternalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch history of status changes for the person
     */
    async findPersonHistoryEventsRaw(requestParameters: FindPersonHistoryEventsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiPersonEvents>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling findPersonHistoryEvents.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/statuses`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiPersonEventsFromJSON(jsonValue));
    }

    /**
     * Fetch history of status changes for the person
     */
    async findPersonHistoryEvents(requestParameters: FindPersonHistoryEventsRequest, initOverrides?: RequestInit): Promise<InternalApiPersonEvents> {
        const response = await this.findPersonHistoryEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
